import { select, takeLatest } from 'redux-saga/effects';

import { environment } from 'environments/environment';
import { createActionCreator, createActionType } from 'helpers/redux/reduxHelpers';
import { history } from 'helpers/store/rootReducer';
import { isComingFromLFR } from 'saga/appHandlers/ducks';

/* ACTION TYPES */
export enum BacklinkActionType {
  GoBack = '@@Backlinker/GO_BACK',
}

/* ACTIONS */
export const goBackAction = createActionCreator(BacklinkActionType.GoBack);

function* goBack() {
  const fromLFR: boolean = yield select(isComingFromLFR);

  if (fromLFR) {
    window.location.href = environment.properties['gui.backlink.backlinker'];
  } else {
    history.goBack();
  }
}

/* EXPORT */
export function* backlinkSaga() {
  yield takeLatest(createActionType(BacklinkActionType.GoBack), goBack);
}
